// Module
var code = "<div> Déconnecter <b>{{utilisateurs[1].prenom}} {{utilisateurs[1].nom}}</b> et <span ng-if=\"utilisateurs[2]\"><b>{{utilisateurs[2].prenom}} {{utilisateurs[2].nom}}</b> et </span> poursuivre&nbsp;? </div>";
// Exports
module.exports = code;